<template>
  <div class="turn-book-content-wrapper"
    :class="{ translate3d: currentZoom > 1, 'turn-book-content-wrapper-pc': !isMobile }" v-swipeleft="swipeBook"
    v-swiperight="swipeBook">
    <div class="book-viewport" draggable="true" id="fd-book" v-panstart="startMoveBook" v-panmove="moveBook"
      v-panend="endMoveBook" v-pinchstart="startPinch" v-pinchmove="movePinch" v-pinchend="endPinch" v-dbtap="zoomBook"
      v-swipe="debouncedFlipbook" :class="{ 'is-mobile': isMobile }">
      <div id="book" ref="pdfBox" v-show="isShowContent" class="animate-center"
        :class="{ drag: currentZoom > 1, translate: isMove }">
        <div v-for="(item, index) in pages" v-bind:key="index">
          <!-- 如果是正常页 -->
          <div class="page" :class="{ 'is-mobile': isMobile }">
            <div class="pageLoading" v-show="isloading[index]" :class="{ 'mobile-translate3d': isMobile && !isMI8 }">
              <img src="@imgs/bookshelfdetail/loading.gif" />
            </div>
            <div class="page-img-wrapper">
              <div v-if="(longPress === 0 && isMobile && !isPaper) || (isPaper && bookData.readModel !== 2)"
                @touchstart="imgTouch" class="img-shar"></div>
              <img class="page-img" :usemap="'#planetmap' + index" :ref="'img' + index"
                :class="{ 'mobile-translate3d': isMobile && !isMI8, 'no-touch': longPress === 0 }"
                @mousedown="imgMouseDown" @load="goload(index)" v-show="!isloading[index]" />
            </div>
            <div class="shadow"
              :class="{ right: index % 2 != 0 && !isMobile, left: index % 2 == 0 || isMobile, 'mobile-translate3d': isMobile && !isMI8 }">
            </div>
            <div>
              <div class="searchMask"
                :style="{ width: subItem.width, height: subItem.height, left: subItem.x, top: subItem.y, background: subItem.bg ? subItem.bg : '' }"
                v-for="(subItem, subIndex) in item.posiArr" :key="subIndex"
                v-show="item.posiArr && item.posiArr.length > 0 && isShowYellow"></div>
            </div>
            <div v-for="(coord, coordindex) in item.coordinates" v-bind:key="coordindex + 100" class="res-node area"
              :data-index="coordindex" :data-type="coord.type" :style="{
                top: coord.topScale + 'px',
                left: coord.leftScale + 'px',
                width: coord.widthScale + 'px',
                height: coord.heightScale + 'px',
                zIndex: coord.zIndex + 10
              }" @click="resNodeClick($event, coord, item)"></div>
            <div v-for="(res, resindex) in item.resources" v-bind:key="resindex" v-show="!isloading[index]"
              :class="{ 'res-node': true, audio: res.type === 'audio', video: res.type === 'video', link: res.type === 'link', picture: res.type === 'picture' }"
              :data-index="resindex" :data-type="res.type" :style="{
                top: res.topScale + 'px',
                left: res.leftScale + 'px',
                width: res.widthScale + 'px',
                height: res.heightScale + 'px',
                'z-index': res.type === 'picture' ? 1 : res.zindex + 1000001,
                'background-image': res.type === 'picture' ? `url(${res.path})` : ''
              }" @click="resNodeClick($event, res, item)">
              <img :src="res.btnPath && res.btnStyle == 1 ? res.btnPath : audioDefaultIcon" v-if="res.type === 'audio'"
                @click="resNodeImgClick($event, res)" v-singletap="resNodeImgSingletap" />
              <img :src="res.btnPath && res.btnStyle == 1 ? res.btnPath : videoDefaultIcon"
                v-else-if="res.type === 'video'" @click="resNodeImgClick($event, res)"
                v-singletap="resNodeImgSingletap" />
              <img :src="res.btnPath && res.btnStyle == 1 ? res.btnPath : linkDefaultIcon"
                v-else-if="res.type === 'link'" />
            </div>
          </div>
        </div>
      </div>
      <div id="requ"></div>
    </div>
    <audio ref="audio" :src="playSrc" controls=""></audio>
  </div>
</template>
<script>
import getBook from '@api/getBook'
import '../../plugins/turn.js'
import Thick from '../../assets/audios/thick.mp3'
import Soft from '../../assets/audios/soft.mp3'
import Default from '../../assets/audios/default.mp3'
import turnBookMixin from './turnBookMixin.js'
import digitalPaper from './digitalPaper.js'
import wx from 'weixin-js-sdk'
import { isPureNum, judgeIsMobile, judgeMI8 } from '@/utils'
import { mapState } from 'vuex'
import { debounce } from 'lodash'
import home from '@api/home'

export default {
  name: 'turnBook',
  mixins: [turnBookMixin, digitalPaper],
  data() {
    return {
      isPaper: this.$route.path.indexOf('paper') > -1 || this.$route.path.indexOf('paperContent') > -1, // TODO 接口返回参数 是否为数字报
      isMI8: judgeMI8(),
      mobile: {
        tMatrix: [1, 0, 0, 1, 0, 0],
        initScale: 1,
        ticking: false,
        el: null,
        poscenter: null,
        lastTranslate: null,
        lastcenter: null,
        center: null,
        duration: '',
        maxScale: 9,
        minScale: 1
      },
      reqAnimationFrame: null,
      isReady: false,
      isMove: false,
      oldX: 0,
      oldY: 0,
      lastX: 0,
      lastY: 0,
      qrcodeArr: [
        { name: '支付宝', url: '' },
        { name: '微信', url: '' }
      ],
      activeIndex: 0, // 切换微信支付宝
      playSrc: Default,
      audio: {
        Thick,
        Soft,
        Default
      },
      chargeNextPage: { normal: false, charge: false }, // 如果倒第二页是收费页 需要最后push该对象
      scale: 0,
      lastdeltaX: 0,
      lastdeltaY: 0,
      oldScale: 1,
      nowScale: 1,
      initScale: 1, //初始化scale
      curBoundaryX: null,
      curBoundaryY: null,
      isloading: [],
      decryption_id: 1,
      readingLog: null,
      // zjx 20221219 当前页面索引，从1开始
      currentPageIndex: 0,
      bgAudioPlayStatus: false,
      currentResNodeDataIndex: 0, // 当前激活的音视频按钮的索引
      mediaSrc: {
        audioSrc: '',
        videoSrc: '',
        linkSrc: ''
      },
      audioDefaultIcon: require('@imgs/digital/audio.png'),
      videoDefaultIcon: require('@imgs/digital/video.png'),
      isShowContent: true,
      linkDefaultIcon: require('@imgs/digital/link.png')
    }
  },
  computed: {
    ...mapState('book', ['bookPath', 'play', 'isShowYellow', 'isShowCommerHeader', 'totalPage']),
    shareTitle() {
      return this.$store.state.config.bookObj.shareTitle
    },
    referer() {
      return this.$store.state.config.bookObj.referer && this.$store.state.config.bookObj.referer < this.totalPage ? this.$store.state.config.bookObj.referer : 1
    },
    isEditDrawerShow() {
      return this.$store.state.edit.isEditDrawerShow
    },
    bookHeight() {
      return this.$store.state.common.bookSize.bookHeight
    },
    bookWidth() {
      return this.$store.state.common.bookSize.bookWidth
    },
    bookScale() {
      return this.$store.state.common.bookScale
    },
    soundId() {
      return this.$store.state.config.bookObj.soundId
    },
    longPress() {
      return this.$store.state.config.bookObj.longPress
    },
    lastPage() {
      if (this.$parent.totalPage % 2 == 0) {
        return this.$parent.totalPage
      } else {
        return false
      }
    },
    curBookW() {
      if (this.$parent.splitCurrentPage == 1 || this.$parent.splitCurrentPage == this.lastPage) {
        return ($('.book-viewport')[0].offsetWidth / 2) * this.currentZoom
      } else {
        return $('.book-viewport')[0].offsetWidth * this.currentZoom
      }
    },
    isStaticBook() {
      return this.$store.state.common.isStaticBook
    },
    // zjx 20221219 增加bookData数据绑定获取
    bookData() {
      if (this.$store.state.book.bookData) {
        return this.$store.state.book.bookData
      } else {
        return {}
      }
    },
    // zjx 20221219 增加pageHandle数据绑定获取（默认双页展示）
    pageHandle() {
      if (this.$store.state.book.bookData) {
        if (this.$store.state.book.bookData.referer == 0) {
          return 1
        } else if (this.$store.state.book.bookData.referer > 0) {
          return 2
        } else {
          return 2
        }
      } else {
        return 2
      }
    },
    // zjx 20230103 用于控制移动端头部与底部的展示
    isMobile() {
      return this.$store.state.book.isMobile
    },
    // zjx 20230103 用于控制移动端头部与底部的展示
    timer() {
      return this.$store.state.book.timer
    },
    isShowDigitalArticleView() {
      return this.$store.state.book.isShowDigitalArticleView
    },
    listToEditPageNo() {
      return this.$store.state.edit.listToEditPageNo
    }
  },
  watch: {
    bookPath(val) {
      console.log('watch bookPath:' + val)
      this.init.call(this)
    },
    //个性化设置
    soundId: {
      handler(newId) {
        if (newId == 0) {
          this.playSrc = Default
        } else if (newId == 1) {
          this.playSrc = Thick
        } else if (newId == 2) {
          this.playSrc = Soft
        } else {
          this.playSrc = Default
        }
      },
      immediate: true
    },
    isZoom(isZoom) {
      if (isZoom) {
        this.$nextTick(() => {
          $('#book').turn('disable', true)
          document.querySelector('#book').onmousewheel = null
          document.querySelector('#book').onmousewheel = this.wheelZoomBook.bind(this)
        })
      } else {
        let _zoom = 1
        this.$store.commit('book/UPDATE_ZOOM', _zoom)
        this.oldX = 0
        this.oldY = 0
        this.lastX = 0
        this.lastY = 0
        this.$store.commit('book/UPDATE_TRANSLATE', {
          oldX: this.oldX,
          oldY: this.oldY
        })
        $('#book').turn('disable', false)
        document.querySelector('#book').onmousewheel = null
        document.querySelector('#book').onmousewheel = this.wheelFlipBook.bind(this)
        $('.book-viewport').css({ transform: 'matrix(' + this.currentZoom + ', 0, 0, ' + this.currentZoom + ',' + this.oldX + ',' + this.oldY + ')', transition: 'none 0s ease 0s' })
        this.reload()
      }
    },
    isEditDrawerShow(val) {
      if (this.isReady) {
        this.reload()
      }
    },
    isShowDigitalArticleView() {
      this.resizeDiv()
    }
  },
  methods: {
    imgTouch(e) {
      if (this.longPress === 0) {
        e.preventDefault()
      }
    },
    // 每次全屏状态改变后重置book样式
    fullScreenChange() {
      let isFullScreen = document.fullScreen || document.mozFullScreen || document.webkitIsFullScreen || document.msFullscreenElement
      if (isFullScreen) {
        this.$store.commit('book/UPDATE_IS_SHOW_COMMERHEADER', false)
        $('.edit-personal-wrapper .edit-personal').css({ height: window.screen.height - 310 + 'px' })
      } else {
        this.$store.commit('book/UPDATE_IS_SHOW_COMMERHEADER', true)
        $('.edit-personal-wrapper .edit-personal').css({ height: window.innerHeight - 390 + 'px' })
      }
      this.$nextTick(() => {
        this.reload()
      })
    },
    point2D(x, y) {
      return { x: x, y: y }
    },
    updateElementTransform() {
      this.mobile.el.style.transition = this.mobile.duration
      let tmp = this.mobile.tMatrix.join(',')
      this.mobile.el.style.transform = 'matrix(' + tmp + ')'
      this.mobile.ticking = false
    },
    requestElementUpdate() {
      if (!this.mobile.ticking) {
        window.reqAnimationFrame(this.updateElementTransform)
        this.mobile.ticking = true
      }
    },
    // 初始化缩放等设置
    initMobileSetting() {
      let _this = this
      _this.mobile.el = document.getElementById('fd-book')
      _this.mobile.lastcenter = _this.point2D(
        _this.mobile.el.getBoundingClientRect().left + _this.mobile.el.offsetWidth / 2,
        _this.mobile.el.getBoundingClientRect().top + 40 + _this.mobile.el.offsetHeight / 2
      )
      _this.mobile.poscenter = _this.point2D(0, 0)
      _this.mobile.lastTranslate = _this.point2D(0, 0)
      _this.mobile.center = _this.mobile.lastcenter
      window.reqAnimationFrame = (function () {
        return (
          window[Hammer.prefixed(window, 'requestAnimationFrame')] ||
          function (callback) {
            window.setTimeout(callback, 1000 / 60)
          }
        )
      })()
      _this.requestElementUpdate()
    },
    /**
     * 查询富媒体列表
     * @param params
     * @param callback
     */
    getHotspotList(params, callback) {
      callback(staticOptions.hotspotList)
    },
    /**
     * 数字报详情 - 大样列表
     * @param params
     * @param callback
     */
    getDaYangByEpaperId(params, callback) {
      callback(staticOptions.daYangList)
    },
    /**
     * 数字报详情 - 小样列表
     * @param params
     * @param callback
     */
    getXiaoYangList(params, callback) {
      for (const daYang of staticOptions.daYangList) {
        if (daYang.id === params.dayangId) {
          callback(daYang.xiaoYangList)
          break
        }
      }
    },
    getPageWH(page, callback) {
      // 判断页面当前是否已存在尺寸数据，如果存在，则无需再通过图片进行获取，而是直接返回即可
      let targetPage = this.bookData.pages[page - 1]
      if (targetPage === undefined) {
        callback && callback(0, 0)
        return
      }
      if (targetPage.width > 0 && targetPage.height > 0) {
        callback && callback(targetPage.width, targetPage.height)
        return
      }
      // 获取目标项目的尺寸数据
      let img = new Image()
      if (page === undefined) {
        if (this.pageHandle === 1) {
          // 单页展示（取第一页的尺寸）
          img.src = this.bookData.page[0].url
        } else {
          // 双页展示（取配置页的尺寸）【默认】
          img.src = this.bookData.page[this.referer - 1].url
        }
      } else {
        img.src = targetPage.url
      }
      img.onload = () => {
        // 目标尺寸数据
        let width = img.width
        let height = img.height
        targetPage.width = width
        targetPage.height = height
        callback && callback(width, height)
      }
    },
    loadXiaoYangList(pages) {
      for (let a in pages) {
        if (pages.hasOwnProperty(a)) {
          let width = this.bookData.pages[pages[a] - 1]?.width
          let height = this.bookData.pages[pages[a] - 1]?.height
          let dayangid = this.bookData.pages[pages[a] - 1]?.dayangid
          if (width === undefined || height === undefined || dayangid === undefined) {
            continue
          }
          // 获取小样列表
          const params = {
            dayangId: dayangid
          }
          this.getXiaoYangList(params, (xiaoYangList) => {
            let xiaoyangindex = 1
            this.bookData.pages[pages[a] - 1].coordinates = []
            for (let b in xiaoYangList) {
              if (xiaoYangList.hasOwnProperty(b)) {
                let dingDianCoords = []
                let coordinates = JSON.parse(xiaoYangList[b].coordinates)
                if (coordinates.dingDianCount === 1) {
                  this.pages[pages[a] - 1].coordinates.push({
                    type: 'area',
                    top: coordinates.top,
                    left: coordinates.left,
                    width: coordinates.width,
                    height: coordinates.height,
                    topScale: coordinates.top,
                    leftScale: coordinates.left,
                    widthScale: coordinates.width,
                    heightScale: coordinates.height,
                    xiaoyangindex: xiaoyangindex++,
                    zIndex: coordinates.zIndex >= 0 ? coordinates.zIndex : Math.abs(xiaoYangList.length - b - 1),
                    xiaoyangid: xiaoYangList[b].id
                  })
                } else {
                  for (let c in coordinates.dingDianList) {
                    if (coordinates.dingDianList.hasOwnProperty(c)) {
                      let x = (coordinates.dingDianList[c].split(',')[0].split('%')[0] * width) / 100
                      let y = (coordinates.dingDianList[c].split(',')[1].split('%')[0] * height) / 100
                      dingDianCoords.push(x)
                      dingDianCoords.push(y)
                    }
                  }
                  let dingDianCoordsRect = this.dingDianCoords(dingDianCoords.toString())
                  this.bookData.pages[pages[a] - 1].coordinates.push({
                    type: 'area',
                    top: dingDianCoordsRect.top,
                    left: dingDianCoordsRect.left,
                    width: dingDianCoordsRect.width,
                    height: dingDianCoordsRect.height,
                    topScale: dingDianCoordsRect.top,
                    leftScale: dingDianCoordsRect.left,
                    widthScale: dingDianCoordsRect.width,
                    heightScale: dingDianCoordsRect.height,
                    xiaoyangindex: xiaoyangindex++,
                    zIndex: coordinates.zIndex || Math.abs(xiaoYangList.length - b - 1),
                    xiaoyangid: xiaoYangList[b].id
                  })
                }
              }
            }
            setTimeout(() => {
              this.resizePageResNode()
            }, 100)
          })
        }
      }
    },
    /**
     *  初始化书 需要判断是否是移动端
     * turnCorners pc端可以设置四个角 bl,br,tl,tr 移动端设置bl,br
     *  pc端可以给第一第二页 倒第一到第二页加上hard 移动端只能给第一页加
     */
    init() {
      // if (this.isPaper) {
      // zjx 20221227 富媒体数据获取
      let _this = this
      let timers = new Date().getTime()
      console.log('bookData.path' + this.bookData.path)
      console.log('bookPath' + this.bookPath)
      this.getHotspotList({ module: this.isPaper ? 'epaper' : 'ebook', moduleDataId: this.$route.query.id }, async (hotspotList) => {
        const params = {
          id: this.$route.query.id,
          module: this.isPaper ? 'epaper' : 'ebook'
        }
        this.getDaYangByEpaperId(params, (daYangList) => {
          // 转换大样与页面的关系数据
          let daYangArray = []
          for (let a in daYangList) {
            if (daYangList.hasOwnProperty(a)) {
              daYangArray[daYangList[a].pageNo] = daYangList[a]
            }
          }
          // 构建页面数据格式
          let pages = []
          let totalPages = _this.needPay && this.goodsObj.chargePage < this.totalPage ? this.goodsObj.chargePage : this.totalPage
          this.isShowContent = totalPages > 0
          for (let i = 1; i <= totalPages; i++) {
            let resources = []
            for (let b in hotspotList) {
              if (hotspotList.hasOwnProperty(b)) {
                if (i == hotspotList[b].pageIden) {
                  let type = undefined
                  if (hotspotList[b].contentType === 0) {
                    type = 'audio'
                  } else if (hotspotList[b].contentType === 1) {
                    type = 'video'
                  } else if (hotspotList[b].contentType === 2) {
                    type = 'link'
                  } else if (hotspotList[b].contentType === 3) {
                    type = 'picture'
                  } else if (hotspotList[b].contentType === 4) {
                    type = 'innerVideo'
                  }
                  let coordinates = JSON.parse(hotspotList[b].coordinates)
                  let res = {
                    id: hotspotList[b].id,
                    type: type,
                    top: coordinates.top,
                    left: coordinates.left,
                    width: coordinates.width,
                    height: coordinates.height,
                    topScale: coordinates.top,
                    leftScale: coordinates.left,
                    widthScale: coordinates.width,
                    heightScale: coordinates.height,
                    zindex: parseInt(b),
                    resize: false,
                    edit: false,
                    btnPath: coordinates.btnPath,
                    btnStyle: coordinates.btnStyle
                  }
                  if (type === 'link') {
                    res.href = hotspotList[b].contentPath
                    res.btnPath = hotspotList[b].btnPath
                    res.btnStyle = hotspotList[b].btnStyle
                  } else {
                    res.file = hotspotList[b].contentPath
                    res.fileid = hotspotList[b].fileAttachId
                    res.path = hotspotList[b].contentPath
                    res.controls = hotspotList[b].playControl === 1
                    res.autoplay = hotspotList[b].playAuto === 1
                    res.loopplay = hotspotList[b].playLoop === 1
                    res.btnPath = hotspotList[b].btnPath
                    res.btnStyle = hotspotList[b].btnStyle
                  }
                  if (type === 'video' || type === 'innerVideo') {
                    res.appID = hotspotList[b].appID
                    if (hotspotList[b].vodFileId) {
                      res.fileid = hotspotList[b].vodFileId
                    }
                    res.fileAttachId = hotspotList[b].fileAttachId
                    res.needInit = true
                  }
                  resources.push(res)
                }
              }
            }
            pages.push({
              url: './imgs/' + daYangList[i - 1].pageNo + '.jpg',
              index: i,
              width: 0,
              height: 0,
              resources: resources,
              coordinates: [],
              dayangid: daYangList[i - 1]?.id
            })
          }
          this.bookData.pages = pages
          //
          if (_this.isMobile && this.bookPath === 'nobook') {
            $('.mobile-footer-icon').css('margin-right', '0px')
            document.title = _this.shareTitle
            document.body.style.cssText += 'min-width:auto'
            _this.$store.commit('edit/UPDATE_EDIT_DRAWER_SHOW', false) // 移动端默认不显示目录
            return
          }
          // 初始化一个数组
          let arr = new Array(_this.totalPage)
          for (let i = 0; i < _this.totalPage; i++) {
            arr[i] = true
          }
          this.isloading = arr
          // zjx 20221219 根据页面处理类型，获取需要处理的图片的原始宽高
          if (this.pageHandle === 1) {
            // 单页展示（取第一页的尺寸）
            this.currentPageIndex = 1
          } else {
            // 双页展示（取配置页的尺寸）【默认】
            this.currentPageIndex = this.referer
          }
          this.getPageWH(this.currentPageIndex, (imgWidth, imgHeight) => {
            let targetImageWidth = imgWidth
            let targetImageHeight = imgHeight



            //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
            // zjx 20221219 以下代码为之前的逻辑，我这边进行一点点调整，具体可以参考img.onload内部的代码（开始）
            //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

            // 设置书刊容器size，PC非数字报为双页模式，宽度为2w
            let w = targetImageWidth
            let h = targetImageHeight
            let finalW
            if (_this.isMobile) {
              // 移动端强制单页展示
              finalW = w
              $('.mobile-footer-icon').css('margin-right', '0px')
              document.title = _this.shareTitle
              document.body.style.cssText += 'min-width:auto'
              _this.$store.commit('edit/UPDATE_EDIT_DRAWER_SHOW', false) // 移动端默认不显示目录
            } else if (this.pageHandle === 1) {
              // 单页展示
              finalW = w
            } else {
              // 双页展示【默认】
              finalW = 2 * w
            }
            _this.$store.commit('common/UPDATE_BOOK_SCALE', Number((finalW / h).toFixed(2)))

            //加载图片 TOFIX 图片加载是否可以移动到数据加载
            _this.$store.commit('book/UPDATE_PAGES', pages)

            // 翻书插件初始化
            let display = _this.isMobile ? 'single' : _this.pageHandle === 1 ? 'single' : 'double'
            let option = {
              display: display,
              elevation: 50,
              duration: 800,
              gradients: true,
              autoCenter: true,
              acceleration: _this.isMobile,
              turnCorners: 'bl,br,tl,tr,l,r',
              page: _this.initPage > totalPages ? 1 : _this.initPage || 1,
              pages: _this.totalPage,
              when: {
                turned: function (e, page, view) {
                  //只加载当前也前后三页图片，不开始全部加载
                  _this.$nextTick(() => {
                    for (let i = Math.max(0, page - 4); i < Math.min(page + 3, totalPages); i++) {
                      if (_this.$refs['img' + i][0] && !_this.$refs['img' + i][0].src) {
                        _this.$refs['img' + i][0].src = _this.pages[i].url
                      } else if (!_this.$refs['img' + i][0] && !_this.$refs['img' + i].src) {
                        _this.$refs['img' + i].src = _this.pages[i].url
                      }
                    }
                  })
                  let _thisTurn = this
                  let newPage = $(_thisTurn).turn('view')
                  let todo = function () {
                    _this.$emit('onTurned', page)
                    _this.currentPageIndex = page
                    // 每次翻页记录浏览位置
                    _this.readingLog[_this.decryption_id] = newPage[0]
                    sessionStorage.setItem('readingLog', JSON.stringify(_this.readingLog))
                    _this.$store.commit('book/UPDATE_CURRENT_PAGE', newPage)
                    // zjx 20221218 元素自适应
                    _this.resizePage()
                    _this.resizePageResNode()
                    // 关闭所有元素图片的状态及播放界面
                    _this.resNodeImgClose()
                    _this.currentResNodeDataIndex = 0
                    // 加载某页面的热区数据
                    _this.loadXiaoYangList(_this.currentPageArray)
                    let indexOf = window.location.href.indexOf('page=');
                    if (indexOf > 0) {
                      window.location.href = window.location.href.slice(0, indexOf) + 'page=' + page
                    }
                  }
                  if (display === 'single') {
                    _this.getPageWH(page, () => {
                      todo()
                    })
                  } else {
                    _this.getPageWH(newPage[0], () => {
                      if (newPage.length > 1) {
                        _this.getPageWH(newPage[1], () => {
                          todo()
                        })
                      } else {
                        todo()
                      }
                    })
                  }
                },
                turning: function (e, page, view) {
                  // 移动端才有播放按钮
                  if (_this.play) {
                    _this.$refs.audio.play()
                  }
                }
              }
            }
            // 加载某页面的热区数据
            this.loadXiaoYangList(this.currentPageArray)
            // console.log('init', this.bookData)
            _this.$nextTick(() => {
              // console.log('init111', option)
              $('#book').turn(option)
              _this.reload()
              if (_this.isMobile) {
                _this.initMobileSetting()
              }
              _this.isReady = true
            })
            //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
            // zjx 20221219 结束
            //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
          })
        })
      })
    },
    reload() {
      if (this.isPaper) {
        // zjx 20221219 这里的自适应代码仅处理双页展示效果【默认】
        if (this.pageHandle !== 1) {
          let size = { bookHeight: parseInt($('.turn-book-content-wrapper').height()), bookWidth: parseInt($('.turn-book-content-wrapper').width()) }
          this.$store.commit('common/UPDATE_BOOK_SIZE', size)
          if (this.bookWidth / this.bookHeight > this.bookScale) {
            $('.book-viewport').css({ width: parseInt(this.bookHeight * this.bookScale) + 'px', height: '100%' })
            $('#book').turn('size', parseInt(this.bookHeight * this.bookScale), this.bookHeight)
          } else {
            $('.book-viewport').css({ height: parseInt(this.bookWidth / this.bookScale) + 'px', width: '100%' })
            $('#book').turn('size', this.bookWidth, parseInt(this.bookWidth / this.bookScale))
          }
        }
        // zjx 20221218 元素自适应
        this.resizePage()
        this.resizePageResNode()
      } else {
        let size = { bookHeight: parseInt($('.turn-book-content-wrapper').height()), bookWidth: parseInt($('.turn-book-content-wrapper').width()) }
        this.$store.commit('common/UPDATE_BOOK_SIZE', size)
        if (this.bookWidth / this.bookHeight > this.bookScale) {
          $('.book-viewport').css({ width: parseInt(this.bookHeight * this.bookScale) + 'px', height: '100%' })
          $('#book').turn('size', parseInt(this.bookHeight * this.bookScale), this.bookHeight)
        } else {
          $('.book-viewport').css({ height: parseInt(this.bookWidth / this.bookScale) + 'px', width: '100%' })
          $('#book').turn('size', this.bookWidth, parseInt(this.bookWidth / this.bookScale))
        }
        setTimeout(() => {
          this.resizePageResNode()
        }, 100)
      }
    },
    chooseCurrent(index) {
      this.activeIndex = index
    },
    imgMouseDown(e) {
      e.preventDefault()
    },
    startMoveBook(e) {
      if (this.isZoom) {
        this.isMove = true
        $('#book').turn('disable', true)
      }
      if (this.isMobile && this.mobile.tMatrix[0] > 1) {
        $('#book').turn('disable', true)
        this.mobile.lastTranslate = this.point2D(this.mobile.tMatrix[4], this.mobile.tMatrix[5])
      }
    },
    moveBook(e) {
      if (this.isZoom && this.isMove) {
        this.oldX = this.oldX + e.deltaX - this.lastX
        this.oldY = this.oldY + e.deltaY - this.lastY
        this.lastX = e.deltaX
        this.lastY = e.deltaY
        //  当oldX或者oldY 大于 电子书到边界的距离才触发效果
        $('.book-viewport').css({ transform: 'matrix(' + this.currentZoom + ', 0, 0, ' + this.currentZoom + ',' + this.oldX + ',' + this.oldY + ')', transition: 'left 0.5s, top 0.5s' })
      }
      if (this.isMobile && this.mobile.tMatrix[0] > 1) {
        $('#book').turn('disable', true)
        this.mobile.duration = ''
        this.mobile.tMatrix[4] = this.mobile.lastTranslate.x + e.deltaX
        this.mobile.tMatrix[5] = this.mobile.lastTranslate.y + e.deltaY
        this.requestElementUpdate()
      }
    },
    // 按方向移动dom若干距离
    moveDom(dom, direction, distance) {
      // 采用transform进行移动
      if (!this.isMobile) {
        switch (direction) {
          case 'up':
            this.oldY = this.oldY - distance
            break
          case 'down':
            this.oldY = this.oldY + distance
            break
          case 'left':
            this.oldX = this.oldX - distance
            break
          case 'right':
            this.oldX = this.oldX + distance
            break
          default:
            break
        }
        $(dom).css({
          transform: `matrix(${this.currentZoom},0,0,${this.currentZoom},${this.oldX},${this.oldY})`,
          transition: 'transform 0.5s'
        })
      } else {
        switch (direction) {
          case 'up':
            this.mobile.tMatrix[5] = this.mobile.tMatrix[5] - distance
            break
          case 'down':
            this.mobile.tMatrix[5] = this.mobile.tMatrix[5] + distance
            break
          case 'left':
            this.mobile.tMatrix[4] = this.mobile.tMatrix[4] - distance
            break
          case 'right':
            this.mobile.tMatrix[4] = this.mobile.tMatrix[4] + distance
            break
          default:
            break
        }
        this.requestElementUpdate()
      }
    },
    // 在移动后事件中添加移动补偿
    endMoveBook() {
      if (this.isZoom && this.isMove) {
        this.isMove = false
        this.lastX = 0
        this.lastY = 0
      }
      // 若未放大，则不处理
      if ((!this.isMobile && !this.isZoom) || (this.isMobile && this.mobile.tMatrix[0] === 1)) {
        return
      }
      const bookDom = document.getElementById('fd-book')
      const { top, bottom, left, right } = bookDom.getBoundingClientRect()
      const maxBottom = window.innerHeight - 40
      const maxRight = window.innerWidth
      let maxTop = document.getElementsByClassName('book-content')[0].getBoundingClientRect().top
      const maxLeft = 0
      // 移动端顶部样式不统一导致有40px误差
      if (this.isMobile) {
        maxTop += 40
      }
      // 判断上边缘
      if (top > maxTop && maxBottom < bottom) {
        this.moveDom(bookDom, 'up', Math.min(top - maxTop, bottom - maxBottom))
      }
      // 判断下边缘
      if (maxBottom > bottom && top < maxTop) {
        this.moveDom(bookDom, 'down', Math.min(maxBottom - bottom, maxTop - top))
      }
      // 判断左边缘
      if (left > maxLeft && right > maxRight) {
        this.moveDom(bookDom, 'left', Math.min(left - maxLeft, right - maxRight))
      }
      // 判断右边缘
      if (maxRight > right && left < maxLeft) {
        this.moveDom(bookDom, 'right', Math.min(maxRight - right, maxLeft - left))
      }
    },
    swipeBook(e) {
      if (!this.isMobile) {
        return
      }
      if (this.mobile.tMatrix[0] > 1) {
        return
      }
      if (e.type === 'swipeleft') {
        this.toPage('next')
      } else if (e.type === 'swiperight') {
        this.toPage('previous')
      }
    },
    startPinch(e) {
      $('#book').turn('disable', true)
      this.mobile.duration = ''
      this.mobile.lastTranslate = this.point2D(this.mobile.tMatrix[4], this.mobile.tMatrix[5]) //记录上一次的偏移值
      this.mobile.initScale = this.mobile.tMatrix[0] || 1
      this.mobile.poscenter = this.point2D(e.center.x, e.center.y)
      this.mobile.lastcenter = this.point2D(this.mobile.center.x + this.mobile.lastTranslate.x, this.mobile.center.y + this.mobile.lastTranslate.y) //重新计算放大后的中心坐标
      this.mobile.poscenter = this.point2D(e.center.x - this.mobile.lastcenter.x, e.center.y - this.mobile.lastcenter.y)
      this.requestElementUpdate()
    },
    movePinch(e) {
      $('#book').turn('disable', true)
      this.mobile.tMatrix[0] = this.mobile.tMatrix[3] = this.mobile.initScale * e.scale
      if (this.mobile.tMatrix[0] < this.mobile.minScale) {
        this.mobile.tMatrix[0] = this.mobile.tMatrix[3] = 1
        this.mobile.tMatrix[4] = this.mobile.tMatrix[5] = 0
        return this.updateElementTransform()
      }
      if (this.mobile.tMatrix[0] >= this.mobile.maxScale) {
        this.mobile.tMatrix[0] = this.mobile.tMatrix[3] = this.mobile.maxScale
        return this.updateElementTransform()
      }
      this.mobile.tMatrix[4] = (1 - e.scale) * this.mobile.poscenter.x + this.mobile.lastTranslate.x
      this.mobile.tMatrix[5] = (1 - e.scale) * this.mobile.poscenter.y + this.mobile.lastTranslate.y
      this.requestElementUpdate()
    },
    endPinch() {
      // console.log('endPinch', e)
    },
    debouncedFlipbook() {
      return debounce(this.flipBook, 100)
    },
    flipBook(e) {
      if (e.deltaX > 0) {
        this.pageFirstLimt()
        $('#book').turn('previous')
      } else {
        this.pageLastLimt()
        $('#book').turn('next')
      }
    },
    zoomBook(e) {
      this.clearMoveAdjust() // 放大或缩小前，先清除移动补偿
      if (!this.isMobile) {
        let odd = $(e.target)
          .parent('div')
          .hasClass('odd')
        let pointer = e.changedPointers[0]
        if (
          (odd && pointer.offsetX < $('#book').width() / 2 - 100) ||
          (pointer.offsetY > 100 && pointer.offsetY < $('#book').height() - 100) ||
          (!odd && pointer.offsetX > 100 && pointer.offsetY > 100) ||
          pointer.offsetY < $('#book').height() - 100
        ) {
          let _zoom = this.isZoom ? 1 : 1 + this.baseScale
          this.$store.commit('book/UPDATE_ZOOM', _zoom)
          this.$store.commit('book/UPDATE_IS_ZOOM', !this.isZoom)
          $('.book-viewport').css('transform', 'matrix(' + this.currentZoom + ', 0, 0, ' + this.currentZoom + ', 0, 0)')
          this.reload()
        }
      } else {
        this.mobile.duration = '.3s ease all'
        let nowScale = this.mobile.tMatrix[0]
        if (nowScale != 1 || this.mobile.tMatrix[4] != 0) {
          //scale不等于1，要重回1
          this.mobile.tMatrix[0] = this.mobile.tMatrix[3] = 1
          this.mobile.tMatrix[4] = this.mobile.tMatrix[5] = 0
        } else {
          let pointer = e.center
          let scale = this.mobile.maxScale
          this.mobile.tMatrix[0] = this.mobile.tMatrix[3] = scale
          this.mobile.tMatrix[4] = (1 - scale) * (pointer.x - this.mobile.center.x)
          this.mobile.tMatrix[5] = (1 - scale) * (pointer.y - this.mobile.center.y)
        }
        this.requestElementUpdate()
      }
    },
    wheelFlipBook(event) {
      event.preventDefault()
      if (event.wheelDelta > 0) {
        this.pageFirstLimt()
        $('#book').turn('previous')
      } else {
        this.pageLastLimt()
        $('#book').turn('next')
      }
    },
    wheelZoomBook(event) {
      event.preventDefault()
      if (event.wheelDelta > 0) {
        this.enlarge()
        this.reload()
      } else {
        this.narrow()
        this.reload()
      }
    },
    goload(index) {
      this.$set(this.isloading, index, false)
    },
    isDefaultIcon(src) {
      return src.includes('@imgs/digital') || src.includes('data:image/png;base64')
    },
    // 页面自适应 zjx 20221218
    resizePage() {
      // 单面展示时才需要
      if (this.pageHandle === 1 && this.currentPageIndex >= 1) {
        // 获取窗口尺寸数据
        let windowWidth = parseInt($('.turn-book-content-wrapper').width())
        let windowHeight = parseInt($('.turn-book-content-wrapper').height())
        // 将窗口尺寸更新至UPDATE_BOOK_SIZE
        let size = { bookHeight: windowHeight, bookWidth: windowWidth }
        this.$store.commit('common/UPDATE_BOOK_SIZE', size)
        // 更新当前页面的尺寸
        let page = this.bookData.pages[this.currentPageIndex - 1]
        let scale = Math.min(windowWidth / page.width, windowHeight / page.height)
        let bookWidth = page.width * scale
        let bookHeight = page.height * scale
        if (this.bookWidth / this.bookHeight > this.bookScale) {
          $('.book-viewport').css({ width: bookWidth + 'px', height: '100%' })
          $('#book').turn('size', bookWidth, bookHeight)
        } else {
          $('.book-viewport').css({ width: '100%', height: bookHeight + 'px' })
          $('#book').turn('size', bookWidth, bookHeight)
        }
      }
    },
    resizePageResNode() {
      let eleWindow = document.getElementById('book')
      if (!eleWindow) {
        return
      }
      let elePageList = eleWindow.getElementsByClassName('page-wrapper')
      for (let a in elePageList) {
        if (elePageList.hasOwnProperty(a)) {
          let pageIndex = elePageList[a].getAttribute('page')
          let eleWindowWidth = elePageList[a].offsetWidth
          let eleWindowHeight = elePageList[a].offsetHeight
          let pageData = this.bookData.pages[pageIndex - 1]
          //翻页时暂停视频
          let eleVideos = elePageList[a].getElementsByTagName('video')
          let isCurrentPage = this.currentPageArray.includes(parseInt(pageIndex))
          for (let i = 0; i < eleVideos.length; i++) {
            if (!isCurrentPage) {
              eleVideos[i].pause()
            } else if (eleVideos[i].autoplay) {
              eleVideos[i].play()
            }
          }
          if (pageData.width === 0 || pageData.height === 0) {
            continue
          }
          let eleResNodeList = elePageList[a].getElementsByClassName('res-node')
          let scale = Math.min(eleWindowWidth / pageData.width, eleWindowHeight / pageData.height)
          if (scale === 0) {
            continue
          }
          this.bookData.pages[pageIndex - 1].scale = scale
          for (let b in eleResNodeList) {
            if (eleResNodeList.hasOwnProperty(b)) {
              let width = pageData.width * scale
              let height = pageData.height * scale
              let top = (eleWindowHeight - height) / 2
              let left = (eleWindowWidth - width) / 2
              let eleResNode = eleResNodeList[b]
              let dataIndex = eleResNode.getAttribute('data-index')
              let dataType = eleResNode.getAttribute('data-type')
              let resNode = null
              if (dataType === 'area') {
                resNode = this.bookData.pages[pageIndex - 1].coordinates[dataIndex]
              } else {
                resNode = this.bookData.pages[pageIndex - 1].resources[dataIndex]
              }
              if (resNode) {
                resNode.widthScale = resNode.width * scale
                resNode.heightScale = resNode.height * scale
                resNode.topScale = resNode.top * scale + top
                resNode.leftScale = resNode.left * scale + left
                eleResNode.style.width = resNode.widthScale + 'px'
                eleResNode.style.height = resNode.heightScale + 'px'
                eleResNode.style.top = resNode.topScale + 'px'
                eleResNode.style.left = resNode.leftScale + 'px'

                //内嵌视频初始化
                if (dataType === 'innerVideo' && resNode.needInit === true) {
                  eleResNode.style.background = '#000'
                  let eleSource = document.createElement('SOURCE')
                  let eleVideo = document.createElement('VIDEO')
                  if (resNode.btnPath && resNode.btnStyle === 1) {
                    eleVideo.poster = resNode.btnPath
                  }
                  eleSource.src = resNode.path
                  eleVideo.setAttribute('playsinline', 'true')
                  eleVideo.setAttribute('webkit-playsinline', 'true')
                  eleVideo.style = 'width:100%;height:100%'
                  if (resNode.autoplay) {
                    eleVideo.autoplay = resNode.autoplay
                  }
                  eleVideo.auto = resNode.autoplay
                  eleVideo.controls = resNode.controls
                  eleVideo.appendChild(eleSource)
                  eleResNode.appendChild(eleVideo)
                  /*let player = TCPlayer(eleVideo, {
                    sources: [{src: resNode.path, type: 'video/mp4'}],
                    controls: resNode.controls,
                    autoplay: resNode.autoplay,
                    loop: resNode.loopplay
                  })*/
                  /*this.addAttachPreview(resNode.fileAttachId)*/
                  resNode.needInit = false
                }
              }
            }
          }
        }
      }
    },
    resNodeImgClose() {
      // console.log(this.mediaSrc, this.listToEditPageNo)
      // 如果存在播放界面，则先关闭及取消所有播放界面及状态
      let eleWin = document.getElementById('res-node-window')
      if (eleWin) {
        let eleWindow = document.getElementById('book')
        let elePageList = eleWindow.getElementsByClassName('page-wrapper')
        for (let a in elePageList) {
          if (elePageList.hasOwnProperty(a)) {
            let eleResNodeList = elePageList[a].getElementsByClassName('res-node')
            for (let b in eleResNodeList) {
              if (eleResNodeList.hasOwnProperty(b)) {
                let eleResNode = eleResNodeList[b]
                let dataType = eleResNode.getAttribute('data-type')
                if (dataType === 'audio' || dataType === 'video' || dataType === 'link') {
                  let eleImg = eleResNode.getElementsByTagName('IMG')

                  for (const el of eleImg) {
                    const eleImgIsDefault = this.isDefaultIcon(el.getAttribute('src'))
                    if (eleImgIsDefault) {
                      el.src = require('@imgs/digital/' + dataType + '.png')
                    }
                  }

                  // if (dataType === 'audio') {
                  //   if (eleImgIsDefault) {
                  //     eleImg[0].src = require('@imgs/digital/audio.png')
                  //   }
                  // } else if (dataType === 'video') {
                  //   if (eleImgIsDefault) {
                  //     eleImg[0].src = require('@imgs/digital/video.png')
                  //   }
                  // } else if (dataType === 'link') {
                  //   if (eleImgIsDefault) {
                  //     eleImg[0].src = require('@imgs/digital/link.png')
                  //   }
                  // }
                }
              }
            }
          }
          if (this.bgAudioPlayStatus) {
            document.getElementById('bgAudioFile').play()
          }
        }
        document.body.removeChild(eleWin)
      }
    },
    resNodeClick(e, res, item) {
      if (res.type === 'link') {
        if (res.href === 'pre') {
          $('#book').turn('previous')
        } else if (res.href === 'next') {
          $('#book').turn('next')
        } else if (res.href === 'first') {
          $('#book').turn('page', 1)
        } else if (/^[0-9]+$/.test(res.href)) {
          $('#book').turn('page', res.href)
        } else {
          window.open(res.href)
        }
      } else if (res.type === 'area') {
        this.$emit('onTurnedXiaoYang', res, item)
      }
    },
    resNodeImgClick(e, res) {
      // if (res.type == 'video') {
      //   // this.pages[this.currentPageIndex - 1].resources
      //   this.mediaSrc.videoSrc = res.btnPath
      // } else if (res.type === 'audio') {
      //   this.mediaSrc.audioSrc = res.btnPath
      // } else {
      //   this.mediaSrc.linkSrc = res.btnPath
      // }

      this.resNodeImgClose()
      // 获取当前点击按钮的索引
      let currentResNodeDataIndex = parseInt(e.srcElement.parentNode.getAttribute('data-index')) + 1
      if (currentResNodeDataIndex === this.currentResNodeDataIndex) {
        // 同一个按钮
        console.log('return')
        this.currentResNodeDataIndex = 0
        return
      } else {
        // 不同按钮
        console.log('go')
        this.currentResNodeDataIndex = currentResNodeDataIndex
      }
      this.bgAudioPlayStatus = !document.getElementById('bgAudioFile').paused // 判断背景音乐当前是否正在播放
      //
      let eleWindow = document.createElement('DIV')
      let eleTitle = document.createElement('DIV')
      let eleClose = document.createElement('DIV')
      let eleImg = document.createElement('IMG')
      let eleBox = document.createElement('DIV')
      document.body.appendChild(eleWindow)
      eleImg.src = require('@imgs/digital/close-black.png')
      eleImg.style = 'width:16px;height:16px;'
      eleWindow.appendChild(eleTitle)
      eleWindow.appendChild(eleClose)
      eleWindow.appendChild(eleBox)
      eleWindow.id = 'res-node-window'
      eleWindow.style = 'position:absolute;top:' + e.pageY + 'px;left:' + e.pageX + 'px;z-index:9999;background:#e3e3e3;border:1px solid #999999;'
      eleTitle.style = 'padding:5px;line-height:24px;font-size:16px;'
      eleClose.style = 'position:absolute;right:0;top:0;width:34px;height:34px;text-align:center;line-height:34px;cursor:pointer;'
      eleClose.appendChild(eleImg)
      eleClose.onclick = () => {
        this.resNodeImgClose()
        // this.currentResNodeDataIndex = 0
        return
        if (res.type === 'audio') {
          if (this.bgAudioPlayStatus) {
            document.getElementById('bgAudioFile').play()
          }
          if (res.btnPath) {
            e.target.src = require(res.btnPath)
          } else {
            e.target.src = require('@imgs/digital/audio.png')
          }
        } else if (res.type === 'video') {
          if (this.bgAudioPlayStatus) {
            document.getElementById('bgAudioFile').play()
          }
          if (res.btnPath) {
            e.target.src = require(res.btnPath)
          } else {
            e.target.src = require('@imgs/digital/video.png')
          }
        } else if (res.type === 'link') {
          if (res.btnPath) {
            e.target.src = require(res.btnPath)
          } else {
            e.target.src = require('@imgs/digital/link.png')
          }
        }
        this.currentResNodeDataIndex = 0
        document.body.removeChild(eleWindow)
      }
      eleBox.style = 'padding: 10px;'
      if (res.type === 'audio') {
        let eleAudio = new Audio()
        eleAudio.src = res.path
        eleAudio.controls = res.controls
        eleAudio.loop = res.loopplay
        eleBox.appendChild(eleAudio)
        eleTitle.innerText = '音频'
        // if (res.btnPath) {
        //   e.target.src = require(res.btnPath)
        // } else {
        // e.target.src = require('@imgs/digital/audio-selected.png')
        // }
        if (this.isDefaultIcon(res.btnPath) || res.btnStyle === 0) {
          e.target.src = require('@imgs/digital/audio-selected.png')
        }
        if (res.controls === false) {
          eleWindow.style.display = 'none'
        }
        if (res.autoplay) {
          eleAudio.play()
        }
        if (this.isMobile) {
          eleWindow.style = 'position:absolute;top:0;left:0;width:100%;z-index:9999;background:#e3e3e3;'
          eleAudio.style = 'width:80%;height:34px;margin:3px auto;'
          eleTitle.style = 'display:none;'
          eleBox.style = 'font-size:0;line-height:0;text-align:center;'
          eleClose.style = 'position:absolute;right:3px;top:3px;width:34px;height:34px;text-align:center;line-height:34px;cursor:pointer;'
        }
        if (this.bgAudioPlayStatus) {
          document.getElementById('bgAudioFile').pause()
        }
        this.addAttachPreview(res.fileid)
      } else if (res.type === 'video') {
        let eleSource = document.createElement('SOURCE')
        let eleVideo = document.createElement('VIDEO')
        eleSource.src = res.path
        eleSource.type = 'video/mp4'
        eleVideo.style = 'max-width:500px;'
        eleVideo.appendChild(eleSource)
        eleBox.appendChild(eleVideo)
        eleTitle.innerText = '视频'
        // if (res.btnPath) {
        //   e.target.src = require(res.btnPath)
        // } else {
        // e.target.src = res.btnPath
        // e.target.src = require('@imgs/digital/video-selected.png')

        // }
        if (this.isDefaultIcon(res.btnPath) || res.btnStyle === 0) {
          e.target.src = require('@imgs/digital/video-selected.png')
        }
        if (this.isMobile) {
          eleWindow.style = 'position:absolute;top:0;left:0;width:100%;height:100%;z-index:9999;background:#e3e3e3;'
          eleVideo.style = 'width:100%;height:100%;'
          eleBox.style = 'object-fit: contain;width:100%;height:calc(100% - 45px);'
        } else {
          eleWindow.style = 'position:absolute;top:50%;left:50%;z-index:9999;background:#e3e3e3;opacity:0;'
          eleVideo.style = 'max-width:500px;max-height:500px;'
          eleVideo.oncanplay = () => {
            eleWindow.style.marginLeft = -(eleWindow.offsetWidth / 2) + 'px'
            eleWindow.style.marginTop = -(eleWindow.offsetHeight / 2) + 'px'
            eleWindow.style.opacity = '1'
          }
        }
        eleVideo.auto = res.autoplay
        eleVideo.controls = res.controls
        /*let player = TCPlayer(eleVideo, {
          sources: [{src: res.path, type: 'video/mp4'}],
          controls: res.controls,
          autoplay: res.autoplay,
          loop: res.loopplay
        })*/
        /*this.addAttachPreview(res.fileAttachId)*/
        /*player.on('fullscreenchange', function () {
          if (player.isFullscreen()) {
            eleVideo.style = ''
          } else {
            eleVideo.style = 'max-width:500px;max-height:500px;'
          }
        })*/
        if (this.bgAudioPlayStatus) {
          document.getElementById('bgAudioFile').pause()
        }
      }
    },
    resNodeImgSingletap(e) {
      if (this.isMobile && e.type === 'singletap' && e.target.className.indexOf('fd-js-excludes') < 0) {
        clearTimeout(this.timer)
        this.$store.commit('book/UPDATE_IS_SHOW_FOOTER', false)
        this.$store.commit('book/UPDATE_IS_SHOW_TITLE', false)
      }
    },
    dingDianCoords(dingDianCoords) {
      let arr = dingDianCoords.split(',')
      let xArr = new Array(arr.length / 2)
      let yArr = new Array(arr.length / 2)
      let x = 0,
        y = 0
      let max = 1,
        min = 2
      for (let t = 0; t < arr.length; t = t + 2) {
        xArr[x++] = parseInt(arr[t])
      }
      for (let t = 1; t < arr.length; t = t + 2) {
        yArr[y++] = parseInt(arr[t])
      }
      let x1 = this.find(xArr, min)
      let x2 = this.find(xArr, max)
      let y1 = this.find(yArr, min)
      let y2 = this.find(yArr, max)
      let Left = x1
      let Top = y1
      let Right = parseInt(x2 - x1)
      let Bottom = parseInt(y2 - y1)
      return {
        top: Top,
        left: Left,
        width: Right,
        height: Bottom
      }
    },
    find(arr, type) {
      let tmp = arr[0]
      if (type == 1) {
        for (let loop = 0; loop < arr.length; loop++) if (arr[loop] > tmp) tmp = arr[loop]
        return tmp
      } else if (type == 2) {
        for (let loop = 0; loop < arr.length; loop++) if (arr[loop] < tmp) tmp = arr[loop]
        return tmp
      }
    },
    addAttachPreview(id) {
      const params = {
        fileAttachId: id
      }
      home.addAttachPreview(params)
    },
    resizeDiv() {
      let appDiv = $('#app')
      let appSize = { height: parseInt(appDiv.height()), width: parseInt(appDiv.width()) }
      this.$store.commit('common/UPDATE_APP_SIZE', appSize)
      if (this.isMobile) {
        this.mobile.tMatrix[0] = this.mobile.tMatrix[3] = 1
        this.mobile.tMatrix[4] = this.mobile.tMatrix[5] = 0
        this.updateElementTransform()
        this.reload()
        this.initMobileSetting()
      } else {
        this.reload()
      }
    }
  },
  created() {
    let isIframe = self !== top
    this.readingLog = JSON.parse(sessionStorage.getItem('readingLog')) || {}
    this.initPage = this.$route.query.page || 1
    this.decryption_id = this.bookData.id || 1
    if (this.$route.query.page) {
      this.initPage = this.$route.query.page
    } else {
      if (Object.keys(this.readingLog).length > 0 && this.readingLog[this.decryption_id]) {
        this.$nextTick(() => {
          // 双页的可能存储为0，如果为0处理为1
          this.initPage = this.readingLog[this.decryption_id] == 0 ? 1 : this.readingLog[this.decryption_id]
        })
      }
    }
  },
  mounted() {
    // console.log('mounted')
    // 监听全屏变化，每次变化后重置book样式
    const arr = ['fullscreenchange', 'webkitfullscreenchange', 'mozfullscreenchange', 'msfullscreenchange']
    arr.forEach((item) => {
      document.addEventListener(item, this.fullScreenChange)
    })
    wx.ready(() => {
      this.$refs.audio.play()
      this.$refs.audio.pause()
    })
    this.$store.commit('book/UPDATE_IS_MOBILE', judgeIsMobile())
    let size = { bookHeight: parseInt($('.book-viewport ').height()), bookWidth: parseInt($('.book-viewport ').width()) }
    this.$store.commit('common/UPDATE_BOOK_SIZE', size)
    window.onresize = () => {
      this.resizeDiv()
    }
    document.querySelector('#book').onmousewheel = this.wheelFlipBook
    this.$nextTick(() => {
      this.init()
    })
  },
  beforeDestroy() {
    let eleWin = document.getElementById('res-node-window')
    if (eleWin) {
      document.body.removeChild(eleWin)
    }
    this.currentResNodeDataIndex = 0
  },
  destroyed() {
    window.onresize = null
    this.$store.commit('book/UPDATE_CURRENT_PAGE', [0, 1])
    this.$store.commit('book/UPDATE_PAGES', [])
    this.$store.commit('book/UPDATE_BOOK_PATH', '')
    this.$store.commit('book/UPDATE_IS_ZOOM', false)
    this.$store.commit('book/UPDATE_ZOOM', 1)
    $('.book-viewport').css({ height: '100%', width: '100%' })
    const arr = ['fullscreenchange', 'webkitfullscreenchange', 'mozfullscreenchange', 'msfullscreenchange']
    arr.forEach((item) => {
      document.removeEventListener(item, this.fullScreenChange)
    })
  }
}
</script>
<style lang="scss" scoped>
.fd-book-viewport {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
}

#fd-book {
  width: 300px;
  height: 100px;
}

.fd-book-father {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.turn-book-content-wrapper {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;

  &.translate3d {
    transform: translate3d(0, 0, 0);
  }

  .digital-paper-canvas-wrapper {
    position: absolute;
    left: 0;
    top: 0;
  }

  .book-viewport {
    position: relative;
    height: 100%;
    width: 100%;
    transform-origin: 50% 50%;

    .searchMask {
      background: orange;
      opacity: 0.5;
      position: absolute;
      z-index: 20000;
    }

    .res-node {
      position: absolute;

      img {
        position: absolute;
        top: 0;
        right: 0;
        width: 32px;
        height: 32px;
      }
    }

    .area {
      cursor: pointer;

      &:hover {
        background: rgba(0, 0, 0, 0.1);
      }
    }

    .link {
      cursor: pointer;

      &:hover {
        background: rgba(0, 0, 0, 0.1);
      }
    }

    .picture {
      background-size: contain;
      background-repeat: no-repeat;
    }

    .audio {
      img {
        cursor: pointer;
      }
    }

    .video {
      img {
        cursor: pointer;
      }
    }
  }

  #book {
    width: 100% !important;
    height: 100% !important;
    margin-left: 0px;
    overflow: visible !important;
    z-index: 10;

    &.translate {
      transform: translate3d(0px, 0px, 0px);
    }

    &.animate-center {
      -webkit-transition: margin-left 0.2s ease-in-out;
      -moz-transition: margin-left 0.2s ease-in-out;
      -o-transition: margin-left 0.2s ease-in-out;
      -ms-transition: margin-left 0.2s ease-in-out;
      transition: margin-left 0.2s ease-in-out;
    }

    &.drag {
      cursor: move;
    }

    &.hidden-book {
      visibility: hidden;
    }
  }

  .page {
    background-size: cover;
    background-repeat: no-repeat;
    position: relative;
    overflow: hidden;
    height: 100%;

    area {
      position: absolute;
      top: 0;
      left: 0;
      z-index: 999;
    }

    .page-img-wrapper {
      width: 100%;
      height: 100%;
      background-color: #fff;

      .page-img {
        object-fit: contain;
        height: 100%;
        width: 100%;
        // pointer-events: none; // 长按图片事件（二维码识别）被禁止
      }

      .img-shar {
        position: absolute;
        z-index: 9;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        opacity: 0;
      }
    }

    .pageLoading {
      height: 100%;
      width: 100%;
      background: #fff;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .shadow {
      position: absolute;
      top: 0;
      height: 100%;
      width: 10%;
      z-index: 10;

      &.left {
        left: 0;
        background-image: -webkit-gradient(linear,
            left top,
            right top,
            from(rgba(60, 60, 60, 0.4)),
            color-stop(40%, rgba(60, 60, 60, 0.2)),
            color-stop(60%, rgba(60, 60, 60, 0.1)),
            to(rgba(200, 200, 200, 0)));
        background-image: -webkit-gradient(linear,
            left top,
            right top,
            from(rgba(60, 60, 60, 0.4)),
            color-stop(40%, rgba(60, 60, 60, 0.2)),
            color-stop(60%, rgba(60, 60, 60, 0.1)),
            to(rgba(200, 200, 200, 0)));
      }

      &.right {
        right: 0;
        background-image: linear-gradient(linear,
            right top,
            left top,
            color-stop(0, rgba(60, 60, 60, 0.3)),
            color-stop(0.23, hsla(0, 0%, 98%, 0.05)),
            color-stop(0.28, hsla(0, 0%, 100%, 0.05)),
            color-stop(0.34, hsla(2, 0%, 98%, 0.05)),
            color-stop(0.54, rgba(50, 50, 50, 0.06)),
            color-stop(1, hsla(0, 0%, 78.4%, 0)));
        background-image: -webkit-gradient(linear,
            right top,
            left top,
            color-stop(0, rgba(60, 60, 60, 0.3)),
            color-stop(0.23, hsla(0, 0%, 98%, 0.05)),
            color-stop(0.28, hsla(0, 0%, 100%, 0.05)),
            color-stop(0.34, hsla(2, 0%, 98%, 0.05)),
            color-stop(0.54, rgba(50, 50, 50, 0.06)),
            color-stop(1, hsla(0, 0%, 78.4%, 0)));
      }
    }
  }

  .charge-page {
    background: rgba(255, 255, 255, 1);
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .price-info {
    padding-bottom: 50px;
    font-size: 18px;
    text-align: center;

    .price-num {
      font-size: 30px !important;
      color: #df5813;
      font-size: 24px;
    }
  }

  .price-container {
    width: 330px;
    margin: 0 auto;
  }

  .pay-tab {
    display: inline-block;
    vertical-align: top;
    box-shadow: 2px 2px 4px 0px rgba(169, 169, 169, 0.5);
    border: 2px solid #df5813;
    border-bottom: none;
    width: 66px;
    height: 20px;
    font-size: 14px;
    line-height: 18px;
    text-align: center;
    color: #df5813;
    cursor: pointer;
  }

  .pay-tab:first-child {
    border-radius: 4px 0px 0px 0px;
  }

  .pay-tab:nth-child(2) {
    border-radius: 0px 4px 0px 0px;
    border-left: none;
  }

  .active-tab {
    background: #df5813;
    color: #fff;
  }

  .qrcode {
    width: 150px;
    margin: 0 auto;
    text-align: center;

    .qrcode-img {
      width: 150px;
      height: 150px;
      padding: 15px;
      box-shadow: 2px 2px 4px 0px rgba(169, 169, 169, 0.5);
      border-radius: 4px;
      border: 2px solid rgba(223, 88, 19, 1);
      background: rgba(244, 244, 244, 1);

      img {
        width: 120px;
        height: 120px;
      }
    }
  }

  .pay-info {
    width: 100%;
    height: 30px;
    line-height: 30px;
    text-align: center;
    background: rgba(244, 244, 244, 1);
    box-shadow: 2px 2px 4px 2px rgba(169, 169, 169, 0.5);
  }

  .pay-img {
    width: 100%;
    height: 230px;
    padding: 58px 74px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 2px 2px 4px 2px rgba(169, 169, 169, 0.5);
  }

  .charge-next-page {
    background: url('../../assets/imgs/charge-next-page.png');
    background-size: cover;
  }

  audio {
    display: none;
    position: relative;
  }
}

.turn-book-content-wrapper-pc {
  padding: 0 60px;
}

.no-touch {
  pointer-events: none;
  user-select: none;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  vertical-align: sub;
}

.mobile-translate3d {
  transform: translate3d(0, 0, 0);
  -webkit-backface-visibility: hidden;
  -webkit-perspective: 1000;
  -moz-backface-visibility: hidden;
  -moz-perspective: 1000;
  backface-visibility: hidden;
  perspective: 1000;
}
</style>
